import $ from 'jquery'
import locationFinder from './location-finder'
import { consentCheck } from './consent-handler'

let scriptsLoaded = false
let locationFinderModules
let isConsentRequired = false
let isFirstLoad = true
const consentCookieId = 'C0003'

function init () {
  locationFinderModules = $('.location-finder-module')
  if (locationFinderModules === undefined || locationFinderModules.length === 0) return
  isConsentRequired = $('#search-bar').attr('data-maps-consent-required') === '1'
  if (!isConsentRequired) {
    showWithoutConsent()
  }
  checkAllModules()

  $(window).scroll(function () {
    checkAllModules()
  })

  $('.accept-onetrust-0003').on('click', () => {
    enableElement(this, consentCookieId + ':1')
  })

  $('.onetrust-banner-open').on('click', () => {
    openOneTrustCookieBannerWithCategory(consentCookieId)
  })

  $(document).on('click', '#accept-recommended-btn-handler, .onetrust-close-btn-handler, .get-google-scripts', function () {
    getRequiredScripts()
  })
}

function openOneTrustCookieBannerWithCategory (categoryId) {
  if (typeof OneTrust !== 'undefined') {
    OneTrust.ToggleInfoDisplay()

    const targetCategory = document.querySelector('#onetrust-pc-sdk [data-optanongroupid=' + categoryId + ']')
    if (targetCategory) {
      //Scrolling to missing consent
      targetCategory.scrollIntoView({ behavior: 'smooth', block: 'center' })
      //Open category
      const expandButton = targetCategory.querySelector(':scope > button')
      expandButton.setAttribute('aria-expanded', 'true')
    } else {
      console.error(`Cookie-Category with ID "${categoryId}" not found.`)
    }
  } else {
    console.error('OneTrust not found.')
  }
}

function isInViewport (element) {
  let position = element.getBoundingClientRect()
  return (position.top < window.innerHeight && position.bottom >= 0) || (position.top >= 0 && position.bottom <= window.innerHeight)
}

function checkAllModules () {
  for (let i = 0; i < locationFinderModules.length; i++) {
    if (isInViewport(locationFinderModules[i])) {
      getRequiredScripts()
      locationFinderModules = []
      break
    }
  }
}

function getRequiredScripts () {
  const allowedToLoad = isConsentRequired ? consentCheck(consentCookieId) : true
  if (allowedToLoad == null) {
    setTimeout(getRequiredScripts, 1000)
    return
  }
  if (scriptsLoaded || !allowedToLoad) {
    if (isFirstLoad) {
      locationFinder.showLocationListOnly()
      isFirstLoad = false
    }
    return
  }
  scriptsLoaded = true
  const body = document.getElementsByTagName('body')[0]
  const src = $('.google-maps-external-script-required').first().attr('data-script-url')
  const localPath = $('#search-bar').attr('data-filepath')
  if (body) {
    let markercluster = loadScript(localPath + '/markerclustererplus.min.js', body)
    markercluster.onload = function () {
      let googleMapsScript = loadScript(src, body)
      googleMapsScript.onload = function () {
        let infoboxScript
        infoboxScript = loadScript(localPath + '/infobox.min.js', body)
        infoboxScript.onload = function () {
          locationFinder.init()
          isFirstLoad = false
        }
      }
    }
  } else {
    console.log('Could not find body element')
  }
}

function loadScript (src, body) {
  const js = document.createElement('script')
  js.type = 'text/javascript'
  js.src = src
  body.appendChild(js)
  return js
}

function enableElement (element, id) {
  window.OneTrust.UpdateConsent('Category', id)
}

function showWithoutConsent () {
  $('.location-finder-ask-for-consent').addClass('d-none')
  $('.location-finder-consent-given').removeClass('d-none')
}

export default {
  init
}
